import { Link as LinkIcon, Store } from "lucide-react";
import { Button } from "../styles";

export default function StoreUnavailable({ notFound, onRetry }) {
  return (
    <main className="store-unavailable">
      <section
        className="store-unavailable__card"
        aria-labelledby="store-unavailable-title"
      >
        <div className="store-unavailable__icon" aria-hidden="true">
          <Store size={32} strokeWidth={1.5} />
        </div>
        <h1 id="store-unavailable-title">
          {notFound
            ? "Restauracji nie znaleziono"
            : "Nie udało się wczytać restauracji"}
        </h1>
        <p>
          {notFound
            ? "Sprawdź, czy adres strony jest poprawny, lub skorzystaj z aktualnego linku udostępnionego przez restaurację."
            : "Wystąpił problem z połączeniem. Spróbuj ponownie za chwilę."}
        </p>
        {notFound ? (
          <div className="store-unavailable__domain">
            <LinkIcon size={14} aria-hidden="true" />
            <span>{window.location.host}</span>
          </div>
        ) : (
          <Button className="mt-4" type="button" onClick={onRetry}>
            Spróbuj ponownie
          </Button>
        )}
      </section>
      <footer className="store-unavailable__footer">
        <a href="https://eatally.pl" className="brand-footer__mark">
          eatally
        </a>
      </footer>
    </main>
  );
}
